// frontend/src/utils/execution/pendingExecutionLifecycle.js

export const PENDING_EXECUTION_TIMEOUT_MS = 3 * 60 * 1000;

export function getPendingExecutionAgeMs(pendingAction = null) {
  if (!pendingAction?.createdAt) return Number.POSITIVE_INFINITY;

  const createdAtMs = new Date(pendingAction.createdAt).getTime();
  if (Number.isNaN(createdAtMs)) return Number.POSITIVE_INFINITY;

  return Date.now() - createdAtMs;
}

export function isPendingExecutionExpired(pendingAction = null) {
  return getPendingExecutionAgeMs(pendingAction) > PENDING_EXECUTION_TIMEOUT_MS;
}

export function getScopedCancellationContinuation(value = '') {
  const normalized = String(value).trim();

  const cancellationStarts = [
    /^nevermind\b/i,
    /^never mind\b/i,
    /^cancel\b/i,
    /^forget it\b/i,
    /^no\b/i,
  ];

  for (const pattern of cancellationStarts) {
    const match = normalized.match(pattern);

    if (match) {
      return normalized.slice(match[0].length).trim();
    }
  }

  return '';
}
